import { render } from "./EmployeeAttendanceWidget.vue?vue&type=template&id=58bcc29e&scoped=true"
import script from "./EmployeeAttendanceWidget.vue?vue&type=script&lang=js"
export * from "./EmployeeAttendanceWidget.vue?vue&type=script&lang=js"

import "./employee-attendance-widget.scss?vue&type=style&index=0&id=58bcc29e&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\Azize HRM\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58bcc29e"]])

export default __exports__